import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../styles/index.css';

const Index: React.FC = () => {
    return (
        <div className="index-page">
            {/* Hero Section */}
            <header className="bg-primary text-white text-center py-5">
                <div className="container">
                    <h1><br/>Supercharge Your Business</h1>
                    <p className="lead">
                        Boost your business to new heights with Next Era Office! A comprehensive solution that combines powerful tools, streamlined workflows, and advanced features to drive productivity, efficiency, and growth.
                    </p>
                    <a href="/signup" className="btn btn-light btn-lg mt-3">Try Now</a>
                </div>
            </header>

            {/* Features Section */}
            <section className="py-5">
                <div className="container">
                    <div className="row text-center">
                        {/* Feature 1 */}
                        <div className="col-md-6 mb-4">
                            <i className="bi bi-lightning-charge-fill display-4 text-primary"></i>
                            <h3 className="mt-3">Streamlined Access</h3>
                            <p>Access Anywhere</p>
                        </div>
                        {/* Feature 2 */}
                        <div className="col-md-6 mb-4">
                            <i className="bi bi-gear-fill display-4 text-primary"></i>
                            <h3 className="mt-3">Data Automation</h3>
                            <p>Secured Storage</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section className="bg-light py-5">
                <div className="container">
                    <h2 className="text-center mb-4">Customize Your User Licensing</h2>
                    <p className="text-center">
                        Our licenses start at $5 per month, or $50 per year, per concurrent user. This includes access to most standard CRM features and many other business management tools.
                    </p>
                    <div className="row">
                        {/* Pricing Card 1 */}
                        <div className="col-md-4 mb-4">
                            <div className="card h-100">
                                <div className="card-body text-center">
                                    <h5 className="card-title">Approval Processing</h5>
                                    <p className="card-text">$15/month or $150/year</p>
                                    <p className="card-text">Unlock basic approval routing and processing for your records.</p>
                                </div>
                            </div>
                        </div>
                        {/* Pricing Card 2 */}
                        <div className="col-md-4 mb-4">
                            <div className="card h-100">
                                <div className="card-body text-center">
                                    <h5 className="card-title">Document Templates</h5>
                                    <p className="card-text">$10/month or $100/year</p>
                                    <p className="card-text">Allows creation of documents using document templates.</p>
                                </div>
                            </div>
                        </div>
                        {/* Pricing Card 3 */}
                        <div className="col-md-4 mb-4">
                            <div className="card h-100">
                                <div className="card-body text-center">
                                    <h5 className="card-title">Enterprise Licensing</h5>
                                    <p className="card-text">Contact Us</p>
                                    <p className="card-text">We also offer "private-cloud" systems, which remove many user limitations, starting around $2,400/month.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Storage Pricing Section */}
            <section className="py-5">
                <div className="container">
                    <h2 className="text-center mb-4">Document and File Storage</h2>
                    <p className="text-center">
                        In addition to user access, we provide a range of storage options designed to accommodate your document, image, and file storage needs.
                    </p>
                    <div className="table-responsive">
                        <table className="table table-bordered text-center">
                            <thead className="thead-light">
                                <tr>
                                    <th>Storage Space</th>
                                    <th>Monthly Cost</th>
                                    <th>Annual Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1 GB</td>
                                    <td>$1/month</td>
                                    <td>$10/year</td>
                                </tr>
                                <tr>
                                    <td>10 GB</td>
                                    <td>$4/month</td>
                                    <td>$40/year</td>
                                </tr>
                                <tr>
                                    <td>50 GB</td>
                                    <td>$18/month</td>
                                    <td>$180/year</td>
                                </tr>
                                <tr>
                                    <td>500 GB</td>
                                    <td>$150/month</td>
                                    <td>$1,500/year</td>
                                </tr>
                                <tr>
                                    <td>1 TB</td>
                                    <td>$280/month</td>
                                    <td>$2,800/year</td>
                                </tr>
                                <tr>
                                    <td>5 TB</td>
                                    <td>$1,100/month</td>
                                    <td>$11,000/year</td>
                                </tr>
                                <tr>
                                    <td>50 TB</td>
                                    <td>$8,000/month</td>
                                    <td>$80,000/year</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Footer Section */}
            <footer className="bg-dark text-white text-center py-3">
                <div className="container">
                    <p>&copy; {new Date().getFullYear()} Next Era Office. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Index;
